import React, { useEffect, useRef } from "react";
import { Data } from "./data";
import "./testmonials.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// import required modules
import { Pagination } from 'swiper/modules';

const Testmonials = () => {
  
  return (

    <section className="testmonial container section">
      <h2 className="section__title">My clients say</h2>
      <span className="section__subtitle">Testimonials</span>
      <Swiper
      className="testmonial__container"
      loop={true}
      grabCursor={true}
      spaceBetween={24}
      pagination={{
        clickable: true,
      }}
      breakpoints={{
        576: {
          slidesPerView:2,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 48,
        },
      }}
      modules={[Pagination]}
    >
        {Data.map((comment) => {
          return <SwiperSlide  key={comment.id}>
          
           <div className="testmonial__card" >
            <img src="https://media-mct1-1.cdn.whatsapp.net/v/t61.24694-24/373450579_654482970090636_1945549772825947314_n.jpg?ccb=11-4&oh=01_AdRFBifg6VoXj1M-GgpiaR0Y_zZXqvfaT36UPDuSUuR7ww&oe=6560B944&_nc_sid=e6ed6c&_nc_cat=111" alt="" className="testmonial__img"/>

            <h3 className="testmonial__name">{comment.name}</h3>
            <p className="testmonial__description">{comment.description}</p>
          </div>
          </SwiperSlide>
        })}
        </Swiper>
    </section>
  );
};

export default Testmonials;
